import * as React from 'react';
import './campaign-reports.scss';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { Badge } from 'components';
import { CopyOutlined, DeleteOutlined, ExportOutlined, PlusCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
// import { ClientSidePagination } from "components/pagination/pagination";
import { PaginationList } from '../../../../core/domain/commons/common';
import { getPageNum } from 'core/utils/paggingHelper';
import { copyToClipboard } from 'core/utils/copyToClipboard';
import { formatCardNumber } from 'core/utils/bankDetecter';
import { Modal } from 'components/modal/modal';
import { downloadCSV } from '../../../../core/utils/export-to-file';
import { getAllOldTxIds } from 'core/repositories/old-tx-ids';
import { OldTxId } from 'core/domain/old-tx-ids/old-tx-ids';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { getViaAuth, responseValidator } from 'apis/api';
import { CampaignDetail, Campaigns } from 'core/domain/campaigns/campaigns';
import { API } from 'apis';
import { jFormat } from 'core/utils/jFormat';
import { List, Empty, Spin, Descriptions } from 'antd';

interface FilterValues {
    sourceCampaign: string;
    startDate: string;
    endDate: string;
}

const empty_filters: FilterValues = {
    sourceCampaign: '',
    startDate: '',
    endDate: '',
};

export const CampaignReports: React.FC = () => {
    const [campaigns, setCampaigns] = React.useState<Campaigns>({ campaigns: [] });
    const [campaignDetail, setCampaignDetail] = React.useState<CampaignDetail>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);
    const [detailLoading, setDetailLoading] = React.useState<boolean>(false);
    const [filterValues, setFilterValues] = React.useState<FilterValues>(empty_filters);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const startDateRef = React.useRef();
    const endDateRef = React.useRef();

    const navigate = useNavigate();

    const filterHandle = (clearFilter?: boolean) => {
        setDetailLoading(true);
        var _query = '';

        if (filterValues.sourceCampaign)
            _query += `${_query.includes('?') ? '&' : '?'}sourceCampaign=${filterValues.sourceCampaign}`;

        if (filterValues.startDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}startDate=${jFormat(filterValues.startDate)}`;
        if (filterValues.endDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}endDate=${jFormat(filterValues.endDate)}`;

        getViaAuth<CampaignDetail>(`${API.campaigns?.getDetail}${clearFilter ? '' : _query}`).then((res) => {
            setDetailLoading(false);
            if (responseValidator(res.status)) {
                setCampaignDetail(res.value);
            }
        });
    };

    React.useEffect(() => {
        setLoading(true);
        getViaAuth<Campaigns>(API.campaigns?.getAll).then((res) => {
            setLoading(false);
            if (responseValidator(res.status)) {
                setCampaigns(res.value);
            }
        });
    }, []);

    return (
        <Page className="pmx-campaign-reports" title="گزارش کمپین ها">
            <Card title="لیست گزارش کمپین ها">
                <div className="filter-row">
                    <div className="fields">
                        <DatePicker
                            className="date-picker"
                            value={filterValues.startDate}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.startDate}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    startDate: e.format(),
                                });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.endDate}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.endDate}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({
                                    ...filterValues,
                                    endDate: e.format(),
                                });
                            }}
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            text="حذف فیلتر"
                            type={buttonType.error}
                            onClick={() => {
                                setFilterValues(empty_filters);
                                filterHandle(true);
                            }}
                        />
                    </div>
                </div>
                <div className="campaign-reports-body" style={{ display: 'flex', gap: 16, marginTop: 32 }}>
                    {/* Right column: campaign list (1/4 width) */}
                    <div
                        className="campaign-reports-list"
                        style={{
                            width: '25%',
                            minWidth: 220,
                            borderLeft: '1px solid #f0f0f0',
                            paddingLeft: 16,
                        }}
                    >
                        <h4 style={{ marginBottom: 12 }}>لیست کمپین‌ها</h4>

                        {loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
                                <Spin />
                            </div>
                        ) : campaigns?.campaigns && campaigns?.campaigns?.length > 0 ? (
                            <List
                                size="small"
                                dataSource={campaigns?.campaigns}
                                renderItem={(item) => {
                                    const isActive = filterValues.sourceCampaign === item;

                                    return (
                                        <List.Item
                                            style={{
                                                cursor: 'pointer',
                                                borderRadius: 8,
                                                marginBottom: 4,
                                                paddingInline: 8,
                                                backgroundColor: isActive ? '#e6f7ff' : 'transparent',
                                                border: isActive ? '1px solid #91d5ff' : '1px solid transparent',
                                                transition: 'all 0.2s ease',
                                            }}
                                            onClick={() => {
                                                const newFilters = {
                                                    ...filterValues,
                                                    sourceCampaign: item,
                                                };
                                                setFilterValues(newFilters);
                                                setDetailLoading(true);

                                                let _query = '';

                                                if (item) {
                                                    _query += `${
                                                        _query.includes('?') ? '&' : '?'
                                                    }sourceCampaign=${encodeURIComponent(item)}`;
                                                }

                                                if (newFilters.startDate) {
                                                    _query += `${
                                                        _query.includes('?') ? '&' : '?'
                                                    }startDate=${jFormat(newFilters.startDate)}`;
                                                }

                                                if (newFilters.endDate) {
                                                    _query += `${
                                                        _query.includes('?') ? '&' : '?'
                                                    }endDate=${jFormat(newFilters.endDate)}`;
                                                }

                                                getViaAuth<CampaignDetail>(`${API.campaigns?.getDetail}${_query}`).then(
                                                    (res) => {
                                                        setDetailLoading(false);
                                                        if (responseValidator(res.status)) {
                                                            setCampaignDetail(res.value);
                                                        }
                                                    },
                                                );
                                            }}
                                        >
                                            <List.Item.Meta title={item} />
                                        </List.Item>
                                    );
                                }}
                            />
                        ) : (
                            <Empty description="کمپینی برای نمایش وجود ندارد" />
                        )}
                    </div>

                    {/* Left column: campaign detail (3/4 width) */}
                    <div className="campaign-reports-detail" style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: 12 }}>جزئیات کمپین</h4>

                        {detailLoading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }}>
                                <Spin />
                            </div>
                        ) : campaignDetail ? (
                            <Descriptions
                                bordered
                                column={2}
                                size="small"
                                labelStyle={{ whiteSpace: 'nowrap' }}
                                title={campaignDetail?.campaign?.campaignName}
                            >
                                <Descriptions.Item label="تعداد کل کاربران">
                                    {campaignDetail?.campaign?.totalUsers?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="کاربران احراز هویت شده">
                                    {campaignDetail?.campaign?.countAuthenticatedUsers?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="کاربران با سفارش خرید">
                                    {campaignDetail?.campaign?.usersWithBuyOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="کاربران با سفارش فروش">
                                    {campaignDetail?.campaign?.usersWithSellOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="تعداد سفارش‌های خرید">
                                    {campaignDetail?.campaign?.countBuyOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="تعداد سفارش‌های فروش">
                                    {campaignDetail?.campaign?.countSellOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="مجموع حجم سفارش‌های خرید" span={2}>
                                    {campaignDetail?.campaign?.sumBuyOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                                <Descriptions.Item label="مجموع حجم سفارش‌های فروش" span={2}>
                                    {campaignDetail?.campaign?.sumSellOrders?.toLocaleString('fa-IR')}
                                </Descriptions.Item>
                            </Descriptions>
                        ) : (
                            <Empty description="لطفا یک کمپین را از لیست انتخاب کنید" />
                        )}
                    </div>
                </div>
            </Card>
        </Page>
    );
};
